import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from '@ibe.components/common/confirm-dialog/confirm-dialog.module';
import { StepsModule } from '../steps/steps.module';
// import { TAPCalendarComponent } from './calendar/calendar.tap.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DatesPageComponent } from './dates-page/dates-page.component';
// import { TAPDatesPageComponent } from './dates-page/dates-page.tap.component';
import { BookingOptionsModule } from '../options/options.module';
import { MonthSwitcherComponent } from './month-switcher/month-switcher.component';
// import { GraphComponent } from './graph/graph.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';
// import { OptionsBarComponent } from './options-bar/options-bar.component';
// import { TAPCalendarMonthComponent } from './calendar-month/calendar-month.tap.component';
// import { PlotChartComponent } from './graph/plot-chart/plot-chart.component';
import { ErrorPageModule } from '../error-page/error-page.module';
import { BookAwardFlightsModuleModule } from '../book-award-flights/book-award-flights-module.module';
import { TAPCalendarMonthLoadingComponent } from './calendar-month/calendar-month-loading/calendar-month-loading.component';

/* REPLICATED FILES */
import { INDRADatesPageComponent } from './dates-page/dates-page.indra.component';
import { INDRACalendarComponent } from './calendar/calendar.indra.component';
import { INDRACalendarMonthComponent } from './calendar-month/calendar-month.indra.component';
import { INDRAPlotChartComponent } from './graph/plot-chart/plot-chart.indra.component';
import { INDRAOptionsBarComponent } from './options-bar/options-bar.indra.component';
import { INDRAGraphComponent } from './graph/graph.indra.component';
import { PrintPricePipe } from './calendar-month/pipes/print-price.pipe';
import { PrintMinPricePipe } from './calendar-month/pipes/print-min-price.pipe';

@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		SharedModule,
		ConfirmDialogModule,
		StepsModule,
		BookingOptionsModule,
		BookAwardFlightsModuleModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		ErrorPageModule
	],
	declarations: [
		// PlotChartComponent,
		INDRAPlotChartComponent,
		DatesPageComponent,
		// TAPDatesPageComponent,
		INDRADatesPageComponent,
		CalendarComponent,
		// TAPCalendarComponent,
		INDRACalendarComponent,
		// TAPCalendarMonthComponent,
		INDRACalendarMonthComponent,
		MonthSwitcherComponent,
		// GraphComponent,
		INDRAGraphComponent,
		// OptionsBarComponent,
		INDRAOptionsBarComponent,
		TAPCalendarMonthLoadingComponent,
		PrintPricePipe,
		PrintMinPricePipe
	],
	exports: [
		INDRAOptionsBarComponent
	]
})
export class DatesModule { }
